import { useCallback, useEffect, useRef, useState } from "react";

const RESET_MS = 2000;

/** Copies text and reports a short-lived "copied" state for UI feedback. */
export function useCopyToClipboard(): { copied: boolean; copy: (text: string) => Promise<void> } {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);

  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setCopied(false);
      }, RESET_MS);
    } catch {
      // Clipboard permission denied or unavailable — leave the label unchanged.
    }
  }, []);

  return { copied, copy };
}
